import { bookingConstants } from '../../_constants';
export function bookings(state = {}, action) {
    switch (action.type) {
        case bookingConstants.BOOKING_RESET:
            return {};
        case bookingConstants.BOOKING_FETCHING:
            return {
                ...state,
                bookingFetching: true
            };
        case bookingConstants.BOOKING_FETCHED:
            return {
                ...state,
                bookingFetching: false
            };
        case bookingConstants.BOOKING_SUBMITTING:
            return {
                ...state,
                bookingSubmitting: true
            };
        case bookingConstants.BOOKING_SUBMITTED:
            return {
                ...state,
                bookingSubmitting: false
            };
        case bookingConstants.BOOKING_SCHEDULES:
            return {
                ...state,
                bookingSchedules: action.bookingSchedules
            };
        case bookingConstants.LIST_OF_BOOKINGS_BY_SCHEDULES:
            return {
                ...state,
                bookingsBySchedule: action.bookingsBySchedule
            };
        case bookingConstants.BOOKING_BY_BATCHREF:
            return {
                ...state,
                batchBooking: action.batchBooking
            };
        case bookingConstants.BOOKING_BY_REF:
            return {
                ...state,
                booking: action.booking
            };
        case bookingConstants.MULTIPLE_BOOKING_BY_REF:
            return {
                ...state,
                multipleBookings: action.multipleBookings
            };
        case bookingConstants.CLEAR_MULTIPLE_BOOKING:
            return {
                ...state,
                multipleBookings: null
            };
        case bookingConstants.BOOKING_LINK:
            return {
                ...state,
                bookingLink: action.bookingLink
            };
        case bookingConstants.SEARCH_BOOKINGS:
            return {
                ...state,
                searchBookings: action.searchBookings
            };
        case bookingConstants.BOOKING_FOR_ATW:
            return {
                ...state,
                bookingForAtw: action.bookingForAtw
            };
        case bookingConstants.CY_BRANCH:
            return {
                ...state,
                CyBranch: action.CyBranch
            };
        case bookingConstants.LIST_OF_BOOKINGS_BY_VOYAGE:
            return {
                ...state,
                bookingsByVoyage: action.bookingsByVoyage
            };
        case bookingConstants.VOYAGE_FOR_BOOKING_BATCH:
            return {
                ...state,
                voyageForBookingBatch: action.voyageForBookingBatch
            };
        case bookingConstants.OPERATION_REPORTS:
            return {
                ...state,
                opReports: action.opReports
            };
        case bookingConstants.BOOKING_PRINT_CBS:
            return {
                ...state,
                bookingForCBS: action.bookingForCBS
            };
        case bookingConstants.BOOK_REPORTS:
            return {
                ...state,
                bookReports: action.bookReports
            };
        case bookingConstants.BOOK_CSRREPORTS:
            return {
                ...state,
                bookCSRReports: action.bookCSRReports
            };
        case bookingConstants.VOYAGE_HISTORY:
            return {
                ...state,
                voyageHistory: action.voyageHistory
            };
        case bookingConstants.SQ_BASED_GOODS_REPORT:
            return {
                ...state,
                SQCommodityReport: action.SQCommodityReport
            };
        case bookingConstants.VESSEL_HISTORY:
            return {
                ...state,
                vesselHistory: action.vesselHistory
            };
        case bookingConstants.BOOKING_DOCUMENT_TREE:
            return {
                ...state,
                bookingDocTree: action.bookingDocTree
            };
        case bookingConstants.VOYAGE_SOUNDING:
            return {
                ...state,
                soundings: action.soundings
            };
        case bookingConstants.VOYAGE_SOUNDING_PER_YEAR:
            return {
                ...state,
                soundingPerYear: action.soundingPerYear
            };
        case bookingConstants.VOYAGE_SOUNDING_PER_MONTH:
            return {
                ...state,
                soundingPerMonth: action.soundingPerMonth
            };
        case bookingConstants.VOYAGE_SOUNDING_PER_VESSEL:
            return {
                ...state,
                soundingPerVessel: action.soundingPerVessel
            };
        case bookingConstants.VOYAGE_TALLYSHEET_FINALIZE:
            return {
                ...state,
                TSFinal: action.TSFinal
            };
        case bookingConstants.DWELLTIME_REPORTS:
            return {
                ...state,
                dwtmReport: action.dwtmReport
            };
        case bookingConstants.REVENUE_REPORT:
            return {
                ...state,
                revenueRprt: action.revenueRprt
            };
        case bookingConstants.REVENUE_REPORT_COMPARATIVE:
            return {
                ...state,
                revenueReportComparative: action.revenueReportComparative
            };
        default:
            return state;
    }
}